/**
 * Declaration clauses — the line that opens a blow, one pool per attack
 * profile (AoD §12.1).
 *
 * Deliberately location-free. When a man swings an axe, nobody yet knows where
 * it will land; the hit-location roll has not happened in the fiction even
 * though it has in the code, and a declaration that named the arm would be
 * telling the reader the end of the sentence first. `CLAUSE_TOKENS` enforces
 * this — a `{part}` in here fails the content test.
 */
export const DECLARATIONS = {
    swing: [
        '{attacker} swings {weapon} at {victim}.',
        '{attacker} cuts at {victim} with {weapon}.',
        '{attacker} brings {weapon} round at {victim}.',
    ],
    thrust: [
        '{attacker} thrusts {weapon} at {victim}.',
        '{attacker} drives {weapon} at {victim}.',
        '{attacker} lunges at {victim} with {weapon}.',
    ],
    shot: [
        '{attacker} looses at {victim} with {weapon}.',
        '{attacker} draws and sends an arrow at {victim}.',
        '{attacker} lets fly at {victim} with {weapon}.',
    ],
    bash: [
        '{attacker} swings {weapon} down at {victim}.',
        '{attacker} strikes at {victim} with {weapon}.',
        '{attacker} sweeps {weapon} at {victim}.',
    ],
    bite: [
        '{attacker} lunges at {victim}, jaws open.',
        '{attacker} snaps at {victim}.',
        '{attacker} drives in at {victim} with {weapon} bared.',
    ],
    gore: [
        '{attacker} comes at {victim} head down.',
        '{attacker} drives up at {victim} with {weapon}.',
    ],
    strike: [
        '{attacker} rears over {victim}.',
        '{attacker} comes up and strikes down at {victim} with {weapon}.',
    ],
    toss: [
        '{attacker} sweeps {weapon} across at {victim}.',
        '{attacker} throws {weapon} at {victim} with the whole of its neck behind it.',
    ],
    trample: [
        '{attacker} comes down on {victim} where {victim} lies.',
        '{attacker} tramples over {victim}.',
    ],
    fall: ['{victim} strikes the ground.', 'The ground comes up and takes {victim}.'],
    fire: ['{victim} is caught by {weapon}.', '{weapon} takes hold of {victim}.'],
};
//# sourceMappingURL=declarations.js.map